import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { PaymentProvider } from '../../providers/payment';
import { IUser } from '../../models/user.model';
import { Query } from '@firebase/database-types';
import { UtilitiesProvider } from '../../providers/utilities';
import { AnalyticsData, _ACTIONS } from '../../providers/analytics';

const componentName = 'CartItemComponent';

@Component({
  selector: 'app-cart-item',
  templateUrl: 'cart-item.component.html'
})

export class CartItemComponent implements OnInit {

  @Input() public uidTrack: string;
  @Input() public product: any;
  @Input() public clientId: string;
  @Input() public config: any;
  @Input() public user: IUser;
  @Input() public productIndex: number;
  @Output() public resize = new EventEmitter();

  public maxStockFlag = false;
  public noStockFlag = false;
  public shoppingCartRef: Query;
  public productRef: Query;

  constructor(
    private paymentProvider: PaymentProvider,
    private utilities: UtilitiesProvider,
    private navCtrl: NavController,
    private navParams: NavParams,
    private analytics: AnalyticsData,
  ) { }

  ngOnInit() { }

  /**
   * Delete selected product from shopping cart
   * @author Jhonny Martínez
   * Review: 28-08-2018
   */
  public async delete(product) {
    this.utilities.alert.create({
      title: await this.utilities.translateTextOrObject('Alert'),
      message: await this.utilities.translateTextOrObject('Are you sure to remove this product from shopping cart?'),
      buttons: [{
        text: await this.utilities.translateTextOrObject('Remove'),
        handler: () => {
          const load = this.utilities.setLoading();
          this.paymentProvider.removeProductFromShoppingCart(this.user.info.id, product.id)
            .then(() => this.presentToast('Item deleted correctly'))
            .then(() => {
              // TrackingAction - Detele Product
              this.analytics.savePageTrackOnFirestore(
                componentName,
                _ACTIONS.deleteProductCart,
                this.uidTrack,
                { catalogId: product.id }
              );
            })
            .then(() => load.dismiss());
        }
      }, {
        text: await this.utilities.translateTextOrObject('Cancel'),
        role: 'cancel'
      }]
    }).present();
  }

  /**
   * Push to carrousel catalog page and view the product detail
   * @author Jhonny Martínez
   */
  public view() {
    const eventId = this.navParams.get('eventId');
    const catalogId = this.product.id;
    this.navCtrl.push('catalog-carrousel', { eventId, catalogId });
  }

  public getUrl(image: string) {
    return `url('${image}')`;
  }

  /**
   *
   * @param product
   */
  public calculatePriceWithDiscount(product: any) {
    if (product.sale_discount > 0) {
      return (parseInt(product.sale_price) - (parseInt(product.sale_price) * (parseInt(product.sale_discount) / 100)));
    }

    return product.sale_price
  }

  public calculatePriceReference(product: any) {
    if (product.sale_discount > 0) {
      return product.sale_price
    }

    return null;
  }

  private async presentToast(message) {
    return this.utilities.toast.create({
      message: await this.utilities.translateTextOrObject(message),
      position: 'top',
      duration: 2000
    }).present();
  }

  public reload() {
    this.resize.emit();
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/components/cart-item/cart-item.component.ts